import React from 'react';
import { TextNote } from 'page/Application/ManageProductAndService/Product/component/styled';

const FormNote = ({ text }) => {
  return <TextNote>{text}</TextNote>;
};

export default FormNote;
